import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  de: {
    translation: {
      'contact': 'KONTAKT',
      'contacts': 'KONTAKTE',
      'sundays': 'Sonntags',
      'tuesdays': 'Dienstags',
      'thursdays': 'Donnerstags',
      'bank': 'BANKVERBINDUNG',
      'address': 'ADRESSE',
      'networks': 'NETZWERKEN',
      'main.text': 'Wir helfen Menschen Jesus zu finden und ihm nachfolgen',
      'main.button': 'so findest du uns',
      'about.title': 'Eine Kirche, die relevant ist',
      'about.about-us.title': 'ÜBER UNS',
      'about.about-us.text': 'Wir sind die Kirche Leuchtturm in Hamm. Aber nicht nur eine Kirche, sondern ein Zufluchtsort für bedürftige Menschen. Wir als Kirche möchten einen positiven Beitrag in die Gesellschaft mit einbringen. Es soll unser zu Hause werden.',
      'about.internal.title': 'LOKALER DIENST',
      'about.internal.text': 'Wir als Kirche möchten aktiv bedürftigen Menschen in Hamm und Umgebung eine Hilfe sein und durch die Bibel einen Ausweg aus Schwierigkeiten zeigen. Durch verschiedene Projekte, Kinder- und Jugendarbeit, Flüchtlingshilfe, Bibelkreise und Gottesdienste, aber auch aktive Einbindung in diese Gesellschaft durch Teilnahme in notwendigen Bereichen der Stadt möchten wir lokal etwas beitragen.',
      'about.external.title': 'EXTERNER DIENST',
      'about.external.text': 'Durch unser Hilfswerk Helping Hands, sowie durch die Arbeit sämtlicher freiwilliger Arbeiter beteiligen wir uns als Kirche aktiv in bedürftigen Ländern. In Ländern wo Armut, Krieg und Leid herrscht, sind wir mit allen uns möglichen Mitteln vorne mit dabei.',
      'vers.title': 'Vers des Tages',
      'location.title': 'UNSER STANDORT',
      'location.schedule.1': 'Gottesdienst',
      'location.schedule.2': 'Hauskreis',
      'fillials.title': 'UNSERE PARTNERGEMEINDEN',
      'event.title': 'The next event',
      'event.description': 'The next event description',
      'receiver': 'Empfänger',
    }
  },
  ru: {
    translation: {
      'contact': 'КОНТАКТ',
      'contacts': 'КОНТАКТЫ',
      'sundays': 'Воскресенье',
      'tuesdays': 'Вторник',
      'thursdays': 'Четверг',
      'bank': 'БАНКОВСКИЕ РЕКВИЗИТЫ',
      'address': 'АДРЕС',
      'networks': 'СЕТИ',
      'main.text': 'Мы помогаем людям найти Иисуса и последовать за Ним',
      'main.button': 'как нас найти',
      'about.title': 'ЦЕРКОВЬ, КОТОРАЯ АКТУАЛЬНА',
      'about.about-us.title': 'О НАС',
      'about.about-us.text': 'Мы – христианская церковь в городе Хамм. Но мы не просто церковь, а убежище для нуждающихся людей. Как церковь, мы стремимся внести позитивный вклад в общество. Мы хотим, чтобы это место стало нашим домом.',
      'about.internal.title': 'ВНУТРЕННЕЕ СЛУЖЕНИЕ',
      'about.internal.text': 'Как церковь, мы стремимся активно помогать нуждающимся людям в Хамме и его окрестностях, предлагая через Библию выход из трудных ситуаций. Мы вносим свой вклад через различные проекты: работа с детьми и молодежью, помощь беженцам, библейские кружки и богослужения. Также мы стремимся активно интегрироваться в общество, принимая участие в важных сферах жизни города.',
      'about.external.title': 'ВНЕШНЕЕ СЛУЖЕНИЕ',
      'about.external.text': 'С помощью нашей благотворительной организации «Helping Hands», а также усилиями многочисленных добровольцев, наша церковь активно помогает в странах, где царят бедность, война и страдания. Мы участвуем во всем, что в наших силах, чтобы помогать таким странам.',
      'vers.title': 'Библейский стих дня',
      'location.title': 'НАШЕ МЕСТОПОЛОЖЕНИЕ',
      'location.schedule.1': 'Богослужение',
      'location.schedule.2': 'Домашняя группа',
      'fillials.title': 'НАШИ ФИЛИАЛЫ',
      'event.title': 'The next event rus',
      'event.description': 'The next event description rus',
      'receiver': 'Получатель',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('lang') || 'de',
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;
